<script setup lang="ts">
import NoInputConfirmModal from '@/components/modal/NoInputConfirmModal.vue';

interface Emits {
  (e: 'confirm'): void;
  (e: 'close'): void;
}

interface Props {
  id: number;
  memId: number;
  onConfirm: (id: number, memId: number) => void;
}

const props = defineProps<Props>();
const emit = defineEmits<Emits>();

const isSubmitting = ref(false);

const deleteHandler = () => {
  // console.log('deleteHandler');
  isSubmitting.value = true;
  props.onConfirm(props.id, props.memId);

  setTimeout(() => {
    isSubmitting.value = false;
  }, 300);
};
</script>

<template>
  <NoInputConfirmModal
    title="나누기 삭제하기"
    message="삭제된 나누기는 복구할 수 없습니다."
    modal-type="mind-share-delete"
    confirm-text="삭제하기"
    :is-loading="isSubmitting"
    @confirm="deleteHandler"
  />
</template>
